import { Outlet } from "react-router-dom";
import { AppShell } from "@/shared/components";

export function CrudLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
